<template>
    <div class="delivery-manage">
        <div class="controller-container1290">
            <div class="controller-content">
                <el-radio-group @change="goToPage(pageRadio)" v-model="pageRadio">
                    <el-radio :label="1">配送列表</el-radio>
                    <el-radio :label="2">配送设置</el-radio>
                </el-radio-group>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>
<script>
export default {
    data() {
        return {
            pageRadio: 1,
        }
    },
    methods: {
        goToPage(val) {
            if(val == 1) {
                this.$router.push({
                    'name': 'deliverylist'
                })
            }
            else {
                this.$router.push({
                    'name': 'deliverysetting'
                })
            }
        }
    }
}
</script>

<style scoped>
@import url(../../assets/css/base.css);

.delivery-manage {
    margin: 0 auto;
    background-color: #f1f1f1;
}
.delivery-manage .el-radio {
    position: relative;
    top: 13px;
    font-size: 14px;
}
</style>




// WEBPACK FOOTER //
// src/pages/deliveryManage/DeliveryManage.vue